import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { CameraIcon, UsersIcon, SparklesIcon } from 'lucide-react';
export function AboutConcept() {
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2
      }
    }
  };
  const itemVariants = {
    hidden: {
      opacity: 0,
      y: 20
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6,
        ease: 'easeOut'
      }
    }
  };
  const features = [{
    icon: CameraIcon,
    title: 'Content Creation',
    description: 'Professionelle Shootings an einzigartigen Locations für dein Portfolio und deine Plattformen.'
  }, {
    icon: UsersIcon,
    title: 'Creative Network',
    description: 'Vernetze dich mit ambitionierten Models, Fotografen und Content Creators.'
  }, {
    icon: SparklesIcon,
    title: 'Kuratierte Erlebnisse',
    description: 'Jede Reise wird sorgfältig geplant — von der Location bis zur kreativen Richtung.'
  }];
  return <section id="konzept" className="py-24 md:py-32 px-6 bg-[#f5f5f7] relative" data-id="element-18">
      <div className="max-w-7xl mx-auto" data-id="element-19">
        <motion.div initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-100px'
      }} variants={containerVariants} className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center" data-id="element-20">
          {/* Image Side */}
          <motion.div variants={itemVariants} className="relative h-[500px] lg:h-[700px] rounded-xl overflow-hidden group shadow-md" data-id="element-21">
            <div className="absolute inset-0 bg-white/10 group-hover:bg-transparent transition-colors duration-700 z-10" data-id="element-22" />
            <img src="https://cdn.rawproductionsgmbh.de/shootingtrip/portugalmai2026/portugalmai2026-15.jpg" alt="Creative shooting concept" className="w-full h-full object-cover transition-transform duration-1000 group-hover:scale-105" data-id="element-23" />
          </motion.div>

          {/* Text Side */}
          <div data-id="element-24">
            <motion.span variants={itemVariants} className="block text-xs font-body tracking-[0.3em] text-brand-accent uppercase mb-4" data-id="element-25">
              Das Konzept
            </motion.span>
            <motion.h2 variants={itemVariants} className="text-4xl md:text-5xl font-heading text-[#1a1a2e] mb-8 leading-tight" data-id="element-26">
              Mehr als eine Reise. <br data-id="element-27" />
              <span className="italic text-[#8a8a9a]" data-id="element-28">
                Ein kreatives Erlebnis.
              </span>
            </motion.h2>

            <motion.p variants={itemVariants} className="text-[#4a4a5a] text-lg font-light leading-relaxed mb-12" data-id="element-29">
              Dies sind kuratierte kreative Shooting-Trips für
              TFP-Content-Produktion. Der Fokus liegt auf Inhalten für
              Instagram, Patreon und andere visuelle Plattformen. Wir bieten
              ästhetischen Portfolio-Aufbau, Networking mit Gleichgesinnten und
              einzigartige internationale Locations.
            </motion.p>

            <div className="space-y-8" data-id="element-30">
              {features.map((feature, index) => <motion.div key={index} variants={itemVariants} className="flex gap-6" data-id="element-31">
                  <div className="flex-shrink-0 w-12 h-12 rounded-full border border-[#e2e2e6] flex items-center justify-center bg-white shadow-sm" data-id="element-32">
                    <feature.icon className="w-5 h-5 text-brand-accent" data-id="element-33" />
                  </div>
                  <div data-id="element-34">
                    <h3 className="text-xl font-heading text-[#1a1a2e] mb-2" data-id="element-35">
                      {feature.title}
                    </h3>
                    <p className="text-[#4a4a5a] font-light leading-relaxed" data-id="element-36">
                      {feature.description}
                    </p>
                  </div>
                </motion.div>)}
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}